/**
 * 全局 api
 * 
 * put ->
 *    updateStaffFlag: params => Axios.put(`admin/staff?${Qs.stringify(params)}`),
 */
import Axios from './resources'

export default {
  getCode: params => Axios.post('/back-user-web/mix/proposer/sendSms', JSON.stringify(params)),
  postProposer: params => Axios.post('/back-user-web/mix/proposer', JSON.stringify(params)),
}
